export default "__VITE_ASSET__ehdhx9_i__"